import { useTranslation } from 'react-i18next';

import { cn } from '@/utils';

function Divider({ className }) {
	const { t } = useTranslation();
	return (
		<div
			className={cn(
				'flex items-center gap-4 text-sm text-gray-700 before:h-1/4 before:grow before:border-t before:border-grey-200 after:h-1/4 after:grow after:border-b after:border-grey-200',
				className
			)}
		>
			{t('authModal.or')}
		</div>
	);
}

export default Divider;
